import {
  makeRequired, repeatPasswordValidator,
} from '../../../../../OUI/Inputs';

export const changedPasswordRepeatFieldValidator = makeRequired(repeatPasswordValidator('changedPassword'));
